// extracted by mini-css-extract-plugin
export default {"dndArea":"attachment_dndArea__Am3C8"};